module.exports = __webpack_public_path__ + "static/GooglePlay-6a104b28efa557bd08edff0d8ef5f62a.svg";